import { DefaultPageHeader } from 'layouts';
import { Card, Skeleton } from 'ui';
import { ProgramsSlider } from 'features/programs';
import { useOrganizationRequestContent } from '../hooks';
import { AllPrograms } from './all-programs';

type P = {
  getPathToProgramDetail: (id: string) => string;
  navigateToJoinedPrograms: () => Promise<void>;
  organizationId: string;
};

const ChannelsPrograms = ({ getPathToProgramDetail, navigateToJoinedPrograms, organizationId }: P) => {
  const { allOrganizations, isLoadingOrganizations, requestOrganizationId } = useOrganizationRequestContent({
    organizationId,
  });

  return (
    <>
      <DefaultPageHeader title="Programs" />
      {isLoadingOrganizations || !allOrganizations ? (
        <Skeleton active paragraph={{ rows: 16 }} />
      ) : (
        <>
          <ProgramsSlider
            controls={{ title: 'Featured' }}
            getPathToProgramDetail={getPathToProgramDetail}
            query={{ filter: { organizationId: requestOrganizationId, scope: 'channels' } }}
          />
          <Card title={<Card.Title level={2}>All</Card.Title>}>
            <AllPrograms
              getPathToProgramDetail={getPathToProgramDetail}
              navigateToJoinedPrograms={navigateToJoinedPrograms}
              organizationId={requestOrganizationId}
            />
          </Card>
        </>
      )}
    </>
  );
};

export default ChannelsPrograms;
